<template>
    <div class="table-list lease-done">
        <check-in :contractObj="contractObj" :type="checkInType" loginType="LANDLORD"></check-in>
        <contract-release :cid="contractId" :obj="filterByWord[selected]"></contract-release>
        <alart-msg :display="alart.success" styleType="success" @alartStatus="alart.success = false">
            <span class="title" slot="title">{{msg.success}}</span>
        </alart-msg>
        <alart-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false">
            <span class="title" slot="title">{{msg.error}}</span>
        </alart-msg>
        <new-bill :cid="contractId" :contractSeq="contractSeq" @saveBillStatus="getLeaseDoneList"></new-bill>
        <auto-create :key="'create'+componentKey" :cid="contractId" :isAutoCreate="isAutoCreate" @saveAutoCreate="setAutoCreate" @saveAutoStatus="getLeaseDoneList"></auto-create>
        <auto-send :key="'send'+componentKey" :cid="contractId" :isAutoSend="isAutoSend" @saveAutoSend="setAutoSend" @saveAutoStatus="getLeaseDoneList"></auto-send>
        <modal class="throw-lease" :display="modalState.throwLease" @modalStatus="closeModal('throwLease')" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>退租點交</h1>
            <div class="content">
                確定要退租點交“{{throwLease.name}}”的合約嗎？確定後將通知房客退租點交
            </div>
            <div class="btn-group">
                <button class="default-button" @click="setThrowLease(), $analytics.logEvent('退租點交', { screen_name: '退租點交'})">確認</button>
                <button class="border-button" @click="closeModal('throwLease')">取消</button>
            </div>
        </modal>
        <div class="mask"></div>
        <div class="table-list-title">
            <span class="contract-date">租約起訖日</span>
            <span class="lease-type">租約類型</span>
            <span class="tanant">租客</span>
            <span class="phone">租客手機</span>
            <span class="address">地址</span>
            <span class="record">
                <select-record v-model="recordType"></select-record>
            </span>
            <span class="status">狀態</span>
            <span class="rent">租金</span>
            <!-- <span class="leave-date">剩餘多久到期</span> -->
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-show="filterByWord.length == 0 && leaseDoneList.length != 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <button class="default-button" @click="setFilterDefault">清除篩選</button>
            </div>
            <div v-show="leaseDoneList.length == 0" class="is-empty">0 筆資料</div>
            <ul>
                <li v-for="(house,index) in filterByWord" :key="index">
                    <span class="contract-date">{{getFormatDateTime(house.contractBeginTime)}} - {{getFormatDateTime(house.contractEndTime)}}</span>
                    <span class="lease-type" v-if="house.isPaperContract">紙本合約</span>
                    <span class="lease-type" v-else>一般合約</span>
                    <span class="tanant">{{house.tenantName}}</span>
                    <span class="phone">{{house.tenantPhone}}</span>
                    <span class="address">{{house.address}}</span>
                    <span v-if="recordType === 'WATER'" class="record">{{house.thisMonthWaterUtilityMeter?toCurrency(house.thisMonthWaterUtilityMeter):'-'}}</span>
                    <span v-if="recordType === 'ELECTRICT'" class="record">{{house.thisMonthElectricityUtilityMeter?toCurrency(house.thisMonthElectricityUtilityMeter):'-'}}</span>
                    <span v-if="recordType === 'GAS'" class="record">{{house.thisMonthGasUtilityMeter?toCurrency(house.thisMonthGasUtilityMeter):'-'}}</span>
                    <span class="status">
                        <span class="red" v-if="house.tenantReleaseTime">房客申請退租</span>
                        <span class="blue" v-else-if="house.contractStatus == 9 && !house.isLandlordReleasedContract">進行中</span>
                        <span class="gray" v-else-if="house.isLandlordReleasedContract">退租中</span>
                    </span>
                    <span class="rent">{{toCurrency(house.rentPrice)}}</span>
                    <!-- <span class="leave-date">{{house.contractDueDate}} 天</span> -->
                    <span class="action">
                        <dot-dropmenu>
                            <ul >
                                <li v-if="house.isPaperContract" @click="getContractPDF(house.contractCid), $analytics.logEvent('查看紙本合約', { screen_name: '查看紙本合約'})">紙本合約</li>
                                <li v-else @click="getContract(house.contractCid), $analytics.logEvent('查看合約', { screen_name: '查看合約'})">查看合約</li>
                                <li @click="setNewBill(house), $analytics.logEvent('新增帳單', { screen_name: '新增帳單'})">新增帳單</li>
                                <li @click="toBillDetail(house.contractCid), $analytics.logEvent('帳單紀錄', { screen_name: '帳單紀錄'})">帳單紀錄</li>
                                <li @click="$analytics.logEvent('入住點交', { screen_name: '入住點交'}), houseCheckIn(house, 'CHECK_IN')"
                                    v-if="house.checkInStatus==='NORMAL'">入住點交</li>
                                <li @click="$analytics.logEvent('入住點交明細', { screen_name: '入住點交明細'}), houseCheckIn(house, 'DETAIL')"
                                    v-else>入住點交明細</li>
                                <li @click="$analytics.logEvent('房客拍表紀錄', { screen_name: '房客拍表紀錄'}), toMeterRecord(house.contractSeq)"
                                    >房客拍表紀錄</li>
                                <li @click="contractId = house.contractCid, isAutoCreate = house.isAutoCreated, setAutoCreate(), $analytics.logEvent('自動收租', { screen_name: '自動收租'})">自動收租</li>
                                <li @click="contractId = house.contractCid, isAutoSend = house.isAutoSend, setAutoSend(), $analytics.logEvent('收租提醒', { screen_name: '收租提醒'})">收租提醒</li>
                                <li v-if="house.tenantReleaseTime" @click="contractId = house.contractCid, selected = index, releaseContract()">房客已申請退租</li>
                                <li v-if="house.contractStatus == 9 && !house.isLandlordReleasedContract" @click="setThrowLease(house.contractCid, house.isPaperContract)">退租點交</li>
                            </ul>
                        </dot-dropmenu>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import newBill from '@/components/widge/newBill.vue';
import autoCreate from '@/components/widge/autoCreate.vue';
import autoSend from '@/components/widge/autoSend.vue';
import contractRelease from '@/components/widge/modal/contractRelease.vue';
import checkIn from '@/components/bussiness/widges/modals/checkIn.vue';
import selectRecord from '@/components/bussiness/widges/input/selectRecord.vue';

import { mapGetters } from 'vuex'
import { 
    apiGetContractPDF
    } from "@/apis/api.js"; 
export default {
    data () {
        return{
            // leaseDoneList: [],
            recordType: 'WATER',
            filterEmpty: false,
            leaseDataEmpty: false,
            leaseDataError: false,
            isLoading: true,
            contractId: null,
            contractSeq: null,
            isAutoCreate: false,
            isAutoSend: false,
            componentKey: 0,
            selected: 0,
            modalState: {
                throwLease: false
            },
            throwLease: {
                contractCid: null,
                name: null,
            },
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                error: null,
            },
            checkInType: 'CHECK_IN',
            contractObj: null
        }
    },
    created () {
        this.getLeaseDoneList()
    },
    watch: {
        newBill: {
            handler: function (val) {
                if(val.rent){
                    if(this.checkIsNum(val.rent)){
                        this.error.newBill.rent = ''
                    }else{
                        this.error.newBill.rent = '請填寫數字'
                    }
                }
                if(val.gasBill) {
                    if(this.checkIsNum(val.gasBill)){
                        this.error.newBill.gasBill = ''
                    }else{
                        this.error.newBill.gasBill = '請填寫數字'
                    }
                }
                if(val.tvBill) {
                    if(this.checkIsNum(val.tvBill)){
                        this.error.newBill.tvBill = ''
                    }else{
                        this.error.newBill.tvBill = '請填寫數字'
                    }
                }
                if(val.waterBill) {
                    if(this.checkIsNum(val.waterBill)){
                        this.error.newBill.waterBill = ''
                    }else{
                        this.error.newBill.waterBill = '請填寫數字'
                    }
                }
                if(val.parkinBill) {
                    if(this.checkIsNum(val.parkingBill)){
                        this.error.newBill.parkingBill = ''
                    }else{
                        this.error.newBill.parkingBill = '請填寫數字'
                    }
                }
                if(val.electricityBill) {
                    if(this.checkIsNum(val.electricityBill)){
                        this.error.newBill.electricityBill = ''
                    }else{
                        this.error.newBill.electricityBill = '請填寫數字'
                    }
                }
                if(val.interneBill) {
                    if(this.checkIsNum(val.internetBill)){
                        this.error.newBill.internetBill = ''
                    }else{
                        this.error.newBill.internetBill = '請填寫數字'
                    }
                }
                if(val.cleaningBill) {
                    if(this.checkIsNum(val.cleaningBill)){
                        this.error.newBill.cleaningBill = ''
                    }else{
                        this.error.newBill.cleaningBill = '請填寫數字'
                    }
                }
                if(val.managementBill) {
                    if(this.checkIsNum(val.managementBill)){
                        this.error.newBill.managementBill = ''
                    }else{
                        this.error.newBill.managementBill = '請填寫數字'
                    }
                }
            },
            deep: true
        },
    },
    methods: {
        setFilterDefault: function () {
            this.$store.dispatch('setFilterDefault')
        },
        getLeaseDoneList: function () {
            this.$store.dispatch('getLeaseDoneMgtList')
        },
        getContract: function (cid) {
            window.open('/contractPaper?cid='+cid, "_blank")
        },
        closeModal: function (type) {
            this.$store.commit('modalStatus/set_modal_mode', false)
            if( type == 'newBill' ){
                this.modalState.newBill = false
                this.setNewBillDefault()
            }else if( type == 'throwLease' ){
                this.modalState.throwLease = false
            }
        },
        houseCheckIn: function (contractObj, type) {
            this.checkInType = type
            this.contractObj = contractObj
            document.getElementsByClassName('lease-management-default')[0].style.zIndex = '9'
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizCheckIn'})
        },
        checkIsNum: function (num) {
            let numerical = /^[0-9]*$/
            return numerical.test(num)?true:false
        },
        toContractDetail: function (cid) {
            window.open('/landlord/leasemanagement/contractdetail?cid='+cid)
        },
        toBillDetail: function (cid) {
            this.$router.push({ name: 'BillDetail', query: { 'cid': cid }})
        },
        toMeterRecord: function (seq) {
            this.$router.push({name: 'meterRecord', query: {'contractSeq': seq}})
        },
        setThrowLease: function (cid, isPaper) {
            if(isPaper){
                this.$router.push({name: 'contractPdf', query: {'cid': cid, 'type': 'release'}})
            }else{
                this.$router.push({name: 'contractPaper', query: {'cid': cid, 'type': 'release'}})
            }
        },
        getContractPDF: function (cid) {
            apiGetContractPDF(cid)
            .then( res => {
                console.log(res)
                
                if(res.status == 200){
                    const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf;charset-UTF-8' }));
                    window.open(url);
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        setNewBill: function (item) {
            this.contractId = item.contractCid
            this.contractSeq = item.contractSeq
            this.$store.dispatch('sendEventLog', 'CREATE_BILL')  
            this.$store.dispatch('setModalStatus', {state: true, type: 'newBill'})
            document.getElementsByClassName('lease-management-default')[0].style.zIndex = '9'
            this.$store.commit('modalStatus/set_modal_mode', true)
        },
        setAutoCreate: function () {
            this.componentKey += 1
            this.$store.dispatch('setModalStatus', {state: true, type: 'autoCreate'})
            document.getElementsByClassName('lease-management-default')[0].style.zIndex = '9'
            this.$store.commit('modalStatus/set_modal_mode', true)
        },
        setAutoSend: function () {
            this.componentKey += 1
            this.$store.dispatch('setModalStatus', {state: true, type: 'autoSend'})
            document.getElementsByClassName('lease-management-default')[0].style.zIndex = '9'
            this.$store.commit('modalStatus/set_modal_mode', true)
        },
        setBillStatus: function (value) {
            this.getLeaseDoneList()
        },
        releaseContract: function () {
            this.$store.dispatch('setModalStatus', {state: true, type: 'contractRelease'})
        },
    },
    computed: {
        // fileterByCounty: function () {
        //     return this.leaseDoneList.filter((leaseItem) => {
        //         if(this.filterQuery.county){
        //             if(leaseItem.county.includes(this.filterQuery.county) == true){
        //                 return leaseItem
        //             }
        //         }else{
        //             return leaseItem
        //         }
        //     });
        // },
        // fileterByDistrict: function () {
        //     return this.fileterByCounty.filter((leaseItem) => {
        //         if( this.filterQuery.district){
        //             if(leaseItem.district.includes(this.filterQuery.district) == true){
        //                 return leaseItem
        //             }
        //         }else{
        //             return leaseItem
        //         }
        //     });
        // },
        // filterByRent: function () {
        //     return this.fileterByDistrict.filter((leaseItem) => {
        //         if( this.filterQuery.rent ){
        //             if( this.filterQuery.rent[0] <= leaseItem.rentPrice && this.filterQuery.rent[1] >= leaseItem.rentPrice ){
        //                 return leaseItem
        //             }
        //         }else{
        //             return leaseItem
        //         }
        //     });
        // },
        // filterByDesposit: function () {
        //     return this.filterByRent.filter((leaseItem) => {
        //         if( this.filterQuery.desposit ){
        //             if( this.filterQuery.desposit[0] <= leaseItem.rentDeposit && this.filterQuery.desposit[1] >= leaseItem.rentDeposit ){
        //                 return leaseItem
        //             }
        //         }else{
        //             return leaseItem
        //         }
        //     });
        // },
        // filterByRentDate: function () {
        //     return this.filterByDesposit.filter((leaseItem) => {
        //         if( this.filterQuery.rentDate ){
        //             let rentDate = new Date(leaseItem.billDueTime),
        //                 filterRentDate = Date.parse(this.filterQuery.rentDate).valueOf()

        //             rentDate = rentDate.setHours(rentDate.getHours()-8)
        //             // console.log(rentDate.setHours(rentDate.getHours()-8))
        //             // console.log(filterRentDate)
        //             if( filterRentDate == rentDate ){
        //                 return leaseItem
        //             }
        //         }else{
        //             return leaseItem
        //         }
        //     });
        // },
        // filterByContractDate: function () {
        //     return this.filterByRentDate.filter((leaseItem) => {
        //         console.log(leaseItem)
        //         if( this.filterQuery.contractDate[0] && this.filterQuery.contractDate[1] ){
        //             let rentDateStart = Date.parse(leaseItem.contractBeganDate).valueOf(),
        //                 rentDateEnd = Date.parse(leaseItem.contractEndTime).valueOf(),
        //                 filterRentDateStart = Date.parse(this.filterQuery.contractDate[0]).valueOf(),
        //                 filterRentDateEnd = Date.parse(this.filterQuery.contractDate[1]).valueOf()
                        
        //             if( filterRentDateStart <= rentDateStart && rentDateEnd <= filterRentDateEnd ){
        //                 return leaseItem
        //             }
        //         }else{
        //             return leaseItem
        //         }
        //     });
        // },
        // filterByArrears: function () {
        //     return this.filterByContractDate.filter((leaseItem) => {
        //         if( this.filterQuery.arrears){
        //             if(leaseItem.billStatus == this.filterQuery.arrears ){
        //                 return leaseItem
        //             }
        //         }else{
        //             return leaseItem
        //         }
        //     });
        // },
        filterByWord: function () {
            return this.leaseDoneList.filter((leaseItem) => {
                if( this.filterWord ){
                    if( leaseItem.tenantName.includes(this.filterWord) || leaseItem.address.includes(this.filterWord) || leaseItem.tenantPhone.includes(this.filterWord) ){
                        return leaseItem
                    }
                }else{
                    return leaseItem
                }
            });
        },
        // filterResult: function () {
        //     if( this.leaseDataEmpty == false && this.leaseDataError == false && this.isLoading == false ){
        //         if( this.filterByWord.length == 0 ){
        //             this.filterEmpty = true
        //             this.$store.dispatch('setFilterResultTotal', 0)
        //         }else{
        //             this.filterEmpty = false
        //             this.$store.dispatch('setFilterResultTotal', this.filterByWord.length)
        //             return this.filterByWord
        //         }
        //     }
            
        // },
        ...mapGetters({
            filterWord: 'GET_LEASE_MGT_FILTER_WORD',
            filterQuery: 'GET_LEASE_MGT_FILTER_QUERY',
            leaseDoneList: 'GET_LEASE_DONE_MGT_LIST'
        })
    },
    components: {
        'dot-dropmenu': DotDropMenu,
        AlartMsg,
        Modal,
        newBill,
        autoCreate,
        autoSend,
        contractRelease,
        checkIn,
        selectRecord
    }
}
</script>
<style lang="scss" scoped>
    .table-list.lease-done{
        // .table-list-title .contract-date:before{
        //     content: '';
        //     position: absolute;
        //     width: 0;
        //     height: 0;
        //     left: 66px;
        //     top: 2px;
        //     border-style: solid;
        //     border-width: 0 2.5px 4px 2.5px;
        //     border-color: transparent transparent #525956 transparent;
        // }
        // .table-list-title .contract-date:after{
        //     content: '';
        //     position: absolute;
        //     width: 0;
        //     height: 0;
        //     left: 66px;
        //     bottom: 1px;
        //     border-style: solid;
        //     border-width: 4px 2.5px 0 2.5px;
        //     border-color: #525956 transparent transparent transparent;
        // }
        margin-bottom: 290px;
        .table-list-title .contract-date,
        .table-list-body ul li .contract-date{
            position: relative;
            width: 160px;
            margin-right: 30px;
        }
        .table-list-title .lease-type,
        .table-list-body ul li .lease-type{
            width: 56px;
            margin-right: 34px;
        }
        .table-list-title .tanant,
        .table-list-body ul li .tanant{
            width: 56px;
            margin-right: 34px;
        }
        .table-list-title .phone,
        .table-list-body ul li .phone{
            width: 80px;
            margin-right: 34px;
        }
        .table-list-title .address,
        .table-list-body ul li .address{
            width: 150px;
            margin-right: 34px;
            // overflow: hidden;
            // text-overflow: ellipsis;
            // display: -webkit-box;
            // -webkit-box-orient: vertical;
            // -webkit-line-clamp: 1;
        }
        .table-list-title .record,
        .table-list-body ul li .record{
            width: 118px;
            margin-right: 34px;
        }
        .table-list-title .status,
        .table-list-body ul li .status{
            width: 108px;
            margin-right: 34px;
        }
        .table-list-body ul li .status{
            >span{
                width: 108px;
                height: 34px;
                border-radius: 4px;
                font-weight: 500;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .red{
                background-color: rgba(255, 146, 117, 0.1);
                color: #fc7171;
            }
            .gray{
                background-color: #f3f3f3;
                color: #676362;
            }
            .blue{
                background-color: rgba(79, 181, 192, 0.08);
                color: #71aae5;
            }
        }
        .table-list-title .rent,
        .table-list-body ul li .rent{
            width: 51px;
            margin-right: 35px;
        }
        .table-list-body ul li .rent{
            text-align: right;
        }
        #modal.throw-lease{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #a8a5a4;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1280px){
        .table-list.lease-done{
            .table-list-title .contract-date,
            .table-list-body ul li .contract-date{
                margin-right: 30px;
            }
            .table-list-title .lease-type,
            .table-list-body ul li .lease-type{
                margin-right: 37;
            }
            .table-list-title .tanant,
            .table-list-body ul li .tanant{
                margin-right: 37;
            }
            .table-list-title .phone,
            .table-list-body ul li .phone{
                margin-right: 37;
            }
            .table-list-title .address,
            .table-list-body ul li .address{
                margin-right: 37;
            }
            .table-list-title .record,
            .table-list-body ul li .record{
                margin-right: 34px;
            }
            .table-list-title .status,
            .table-list-body ul li .status{
                margin-right: 37;
            }
        }
    
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/leaseManagement/LeaseDoneList.vue